// removed by extract-text-webpack-plugin
module.exports = {"vpImageCollectorContainer":"vpImageCollectorContainer___11H2j","vpHeader":"vpHeader___3gfsO","vpLabel":"vpLabel___1bQuX","vpDescription":"vpDescription___2B3DT","vpRequiredLabel":"vpRequiredLabel___3rFjI","vpDropzoneWrapper":"vpDropzoneWrapper___2xLcS","vpErrorMessage":"vpErrorMessage___2hpOt","vpHelpText":"vpHelpText___2qcMd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/ImageCollector.module.less
// module id = 3816
// module chunks = 33